// "Äänite poistettu. Kumoa": shown once for UNDO_MS after an own recording is deleted
// (recordings/edits.ts). Lives in the shell, so it stays when the deleted row leaves the page.
import { useSyncExternalStore } from 'react';
import { useT } from '../i18n';
import { lastDeletedRecording, subscribeDeleted, undoDelete } from './edits';

export function RecordingUndoToast() {
  const t = useT();
  const d = useSyncExternalStore(subscribeDeleted, lastDeletedRecording, () => null);
  // Voice Dock shows its own Kumoa beside the take while it is on screen
  if (!d || d.inline) return null;
  return (
    <div className="toast" role="status" data-recording-undo>
      <span>{t.recEdit.deleted}</span>
      <div className="toast-actions">
        <button type="button" className="btn btn-small" onClick={() => void undoDelete()}>
          {t.recEdit.undo}
        </button>
      </div>
    </div>
  );
}
